import { MapReport } from "../src/maps";
import $ from "jquery";


/*********************************************************
 * General utilities and loaders for multiple report types
 *********************************************************/

const reports = {
    init() {
        reports.loadMapReports();
    },

    loadMapReports() {
        const maps = $(".map-report-map");
        if (maps.length === 0) return;

        const key = (<any>window).googleMapsApiKey;

        /*reports.ensureScript("/scripts/mapreport.min.js", () => {
            reports.loadGoogleMapApi(key);
        });*/

        reports.loadGoogleMapApi(key);
    },

    ensureScript(script: string, callback?:() => void) {

        const scripts = document.querySelectorAll("script");
        for (let i = 0; i < scripts.length; i++) {
            if (scripts[i].src === script) {
                if (callback) callback();
                return;
            }
        }

        //Add script tag
        const tag = document.createElement("script");
        tag.src = script;
        
        if (callback) {
            tag.addEventListener("load", (e: Event) => {
                callback();
            });
        }

        document.getElementsByTagName("body")[0].appendChild(tag);
    },

    loadGoogleMapApi(apiKey: string) {
        const src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=reports.googleMapApiReady`;
        reports.ensureScript(src);
    },

    googleMapApiReady() {
        const containers = document.getElementsByClassName(MapReport.mapContainerClassName);
        for (let i = 0; i < containers.length; i++) {
            const container = containers.item(i) as HTMLElement;

            const mapReport = new MapReport(container);
        }

        //this.barbTest();

    },

    /*barbTest() {
        for (var i = 0; i <= 150; i += 5) {
            var gen = new SvgBarbGenerator(i);
            $(`<div><span>${i} knots</span> <div>${gen.build()}</div></div>`).appendTo("#BarbTest");;
        }
    }*/


    getCardinalDirection(degrees: number, includeDegrees: boolean = false): string {
        if (degrees == null || degrees < 0 || degrees > 360) return null;

        const directions = ["N", "NNE", "NE", "ENE", "E", "ESE", "SE", "SSE", "S", "SSW", "SW", "WSW", "W", "WNW", "NW", "NNW", "N"];
        const sixteenth = Math.ceil((degrees + 11.25) / 22.5);

        if (includeDegrees) {
            return directions[sixteenth - 1] + " | " + degrees + "°";
        } else {
            return directions[sixteenth - 1];
        }
    },


    pointWindDirImage(degrees: number, color: string = "#000"): any {
        if (degrees == null) return null;
        if (degrees < 0 || degrees > 360) return null;

        // blue fill: #0053ae
        const svg = `<svg version="1.1" xmlns="http://www.w3.org/2000/svg" width="512" height="512" viewBox="0 0 512 512"><path fill="${color}" d="M85.8,2.1L256,172.3L426.1,2.1L256,512L85.8,2.1z" transform="rotate(${degrees},256,256)" /></svg>`;
        const uri = `data:image/svg+xml;base64,${btoa(svg)}`;

        return {
            image: {
                url: uri,
                width: 12,
                height: 12
            }
        }
    },

    lineChartPointCustomize(pointInfo: any) {
        let windDirField: string = null;
        const series = pointInfo.series;

     
        if (series.tag === "WindSpeed") {
            windDirField = "Value_WindDir";
        } else if (series.tag === "WindMax") {
            windDirField = "Value_WindMaxDir";
        } else if (series.tag === "WindMaxDay") {
            windDirField = "Value_WindMaxDayDir";
        }

        if (windDirField) {

            const windDirValue = pointInfo.data[windDirField];

            // Color match the series
            //return reports.pointWindDirImage(windDirValue, series.getOptions().mainSeriesColor);

            // Use default color (black)
            return reports.pointWindDirImage(windDirValue);
        }

        return null;
    },
    
    lineChartTooltipCustomizer(pointInfo: any, unitsByFieldKey: any) {
        const data = pointInfo.point.data;
        const fieldKey = pointInfo.point.series.tag;
        let windDir:number = null;
        let windDirLine = "";

        if (fieldKey === "WindSpeed") {
            windDir = data.Value_WindDir;
        } else if (fieldKey === "WindMax") {
            windDir = data.Value_WindMaxDir;
        } else if (fieldKey === "WindMaxDay") {
            windDir = data.Value_WindMaxDayDir;
        }

        const valueText = pointInfo.valueText + " " + unitsByFieldKey[fieldKey];

        if (windDir != null) {
            windDirLine = reports.getCardinalDirection(windDir, true) + "<br />";
        }

        return {
            html: "<strong>" + valueText + "</strong><br />" + windDirLine + pointInfo.seriesName + "<br /><em>" + pointInfo.argumentText + "</em>"
        };
    },
    
    soilMoistureChartTooltipCustomizer(pointInfo: any, unitsByFieldKey: any) {

        var responseHtml = "";
        var fieldsReported = new Set();
        var dateTime:string = null;

        for (var point = 0; point < pointInfo.points.length; point++) {
            const fieldKey = pointInfo.points[point].point.series.tag;

            if (!fieldsReported.has(fieldKey)) {
                fieldsReported.add(fieldKey);

                var data = pointInfo.points[point].point.data;
                // Get first data point and use that instead of the aggregated data, if the data is aggregated.
                if (typeof pointInfo.points[point].point.aggregationInfo !== "undefined" && typeof pointInfo.points[point].point.aggregationInfo.data !== "undefined" && pointInfo.points[point].point.aggregationInfo.data.length > 0)
                    data = pointInfo.points[point].point.aggregationInfo.data[0];
                
                if (dateTime == null) dateTime = data.Day + " " + data.Time;

                let windDir:number = null;
                let windDirLine = "";

                if (fieldKey === "WindSpeed") {
                    windDir = data.Value_WindDir;
                } else if (fieldKey === "WindMax") {
                    windDir = data.Value_WindMaxDir;
                } else if (fieldKey === "WindMaxDay") {
                    windDir = data.Value_WindMaxDayDir;
                }

                if (windDir != null) {
                    windDirLine = reports.getCardinalDirection(windDir, true) + "<br />";
                }

                const valueText = data["Value_" + fieldKey] + " " + unitsByFieldKey[fieldKey];

                responseHtml += "<tr class='" + (pointInfo.seriesName === pointInfo.points[point].seriesName ? "info" : "") + "'><td class='text-right text-nowrap'> <strong>" + valueText + "</strong> </td><td class='text-nowrap'>" + windDirLine + pointInfo.points[point].seriesName + " </td></tr>";
            }
        }

        responseHtml = "<table class='table table-condensed'><tr><th class='text-nowrap' colspan='2'>" + dateTime + "</th></tr>" + responseHtml + "</table>";

        return {
            html: responseHtml
        };
    }
};

(window as any).reports = reports;


//On page load
$(() => {
    reports.init();
});